import { z, uuidSchema } from '@kc3/validation';
const KNOWLEDGE_ARTICLE_STATUSES = ['draft', 'published'];
const KNOWLEDGE_CATEGORY_STATUSES = ['active', 'inactive'];
const KNOWLEDGE_CONTENT_TYPES = ['knowledgebase', 'faq', 'announcement', 'news'];
export const CreateKnowledgeCategoryRequestSchema = z.object({
    name: z.string().min(1).max(128),
    slug: z.string().min(1).max(128).optional(),
    description: z.string().max(500).nullable().optional(),
    contentType: z.enum(KNOWLEDGE_CONTENT_TYPES).default('knowledgebase'),
    sortOrder: z.number().int().min(0).default(0),
    status: z.enum(KNOWLEDGE_CATEGORY_STATUSES).default('active'),
});
export const UpdateKnowledgeCategoryRequestSchema = z
    .object({
    name: z.string().min(1).max(128).optional(),
    slug: z.string().min(1).max(128).optional(),
    description: z.string().max(500).nullable().optional(),
    contentType: z.enum(KNOWLEDGE_CONTENT_TYPES).optional(),
    sortOrder: z.number().int().min(0).optional(),
    status: z.enum(KNOWLEDGE_CATEGORY_STATUSES).optional(),
})
    .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
});
export const KnowledgeCategoryResponseSchema = z.object({
    id: uuidSchema,
    name: z.string(),
    slug: z.string(),
    description: z.string().nullable(),
    contentType: z.enum(KNOWLEDGE_CONTENT_TYPES),
    sortOrder: z.number().int(),
    status: z.enum(KNOWLEDGE_CATEGORY_STATUSES),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
export const CreateKnowledgeArticleRequestSchema = z.object({
    categoryId: uuidSchema,
    title: z.string().min(1).max(200),
    slug: z.string().min(1).max(200).optional(),
    contentHtml: z.string().min(1),
    status: z.enum(KNOWLEDGE_ARTICLE_STATUSES).default('draft'),
    expiresAt: z.string().datetime().nullable().optional(),
    isPinned: z.boolean().default(false),
});
export const UpdateKnowledgeArticleRequestSchema = z
    .object({
    categoryId: uuidSchema.optional(),
    title: z.string().min(1).max(200).optional(),
    slug: z.string().min(1).max(200).optional(),
    contentHtml: z.string().min(1).optional(),
    status: z.enum(KNOWLEDGE_ARTICLE_STATUSES).optional(),
    expiresAt: z.string().datetime().nullable().optional(),
    isPinned: z.boolean().optional(),
})
    .refine((v) => Object.values(v).some((x) => x !== undefined), {
    message: 'At least one field must be provided',
});
export const KnowledgeArticleResponseSchema = z.object({
    id: uuidSchema,
    categoryId: uuidSchema,
    title: z.string(),
    slug: z.string(),
    contentHtml: z.string(),
    status: z.enum(KNOWLEDGE_ARTICLE_STATUSES),
    createdBy: uuidSchema.nullable(),
    expiresAt: z.string().datetime().nullable(),
    isPinned: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    publishedAt: z.string().datetime().nullable(),
});
export const KnowledgeArticleSearchQuerySchema = z.object({
    q: z.string().min(1).max(200),
    categoryId: uuidSchema.optional(),
    contentType: z.enum(KNOWLEDGE_CONTENT_TYPES).optional(),
    page: z.string().optional(),
    limit: z.string().optional(),
});
export const KnowledgeArticleListQuerySchema = z.object({
    categoryId: uuidSchema.optional(),
    status: z.enum(KNOWLEDGE_ARTICLE_STATUSES).optional(),
    contentType: z.enum(KNOWLEDGE_CONTENT_TYPES).optional(),
    search: z.string().optional(),
    page: z.string().optional(),
    limit: z.string().optional(),
});
export const KnowledgeCategoryListQuerySchema = z.object({
    search: z.string().optional(),
    contentType: z.enum(KNOWLEDGE_CONTENT_TYPES).optional(),
    page: z.string().optional(),
    limit: z.string().optional(),
});
//# sourceMappingURL=knowledge-base.js.map